<template>
  <div class="staff-list-container">
    <div class="search media">
      <div class="media-body">
        <search-input
          @search="searchStaffs"
          placeholder="ค้นหาด้วยชื่อ หรือ email"
        ></search-input>
      </div>
    </div>
    <ul class="staff-status nav tabs">
      <li
        role="presentation"
        class="col tab"
        :class="{ active: tabListActive }"
        data-toggle="tab"
        @click="activeTab('active')"
      >
        ใช้งานอยู่
      </li>
      <li
        role="presentation"
        class="col tab"
        :class="{ active: !tabListActive }"
        data-toggle="tab"
        @click="activeTab('inactive')"
      >
        ไม่ใช้งาน
      </li>
    </ul>
    <div class="col p-0 staff-list">
      <staff-navigation :staffs="filterStaffs" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import SearchInput from "@/components/helper/SearchInput";
import FilterDropdown from "@/components/helper/Dropdown";
import StaffNavigation from "./StaffNavigation";

export default {
  props: {
    selectedTab: String,
    staffs: Array
  },
  components: {
    SearchInput,
    InfiniteLoading,
    FilterDropdown,
    StaffNavigation
  },
  data() {
    return {
      keyword: "",
      tabListActive: true
    };
  },
  computed: {
    filterStaffs() {
      if (this.staffs && this.staffs.length > 0) {
        if (this.tabListActive) {
          return this.staffs
            .filter(staff => staff.deletedAt === null)
            .filter(staff => {
              return (
                staff.firstName.indexOf(this.keyword) !== -1 ||
                staff.lastName.indexOf(this.keyword) !== -1 ||
                staff.email.indexOf(this.keyword) !== -1
              );
            });
        }

        return this.staffs.filter(staff => staff.deletedAt !== null);
      }

      return [];
    }
  },
  watch: {
    selectedTab(val) {
      this.activeTab(val);
    }
  },
  methods: {
    searchStaffs(keyword) {
      this.keyword = keyword;
    },
    activeTab(tab) {
      if (tab === "active") {
        this.tabListActive = true;
      } else {
        this.tabListActive = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.staff-list-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.staff-list {
  overflow: auto;
}
.staff-status {
  height: 54px;
  padding-top: 15px;
  border-bottom: 1px solid #e0e0e0;

  .tab {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: #8c8786;
    cursor: pointer;

    &.active {
      color: #e27024;
      font-weight: bold;
      border-bottom: 2px solid #e27024;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/staff/StaffList.vue